import { useState, useCallback } from 'react';
import ProtocolFieldsService from '../../service';
import { toast } from 'react-toastify';
import formattedTags from '../utils/formattedTags';

function useHandleProtocolListing(recordTypeId) {
  const [protocols, setProtocols] = useState(null);
  const [protocolsQuantity, setProtocolQuantity] = useState(0);
  const [isLoadingProtocols, setIsLoadingProtocols] = useState(false);
  const [protocolOverallSLAInfo, setProtocolOverallSLAInfo] = useState(null);

  const getProtocols = useCallback(
    async (params = {}, showToastMessage = true) => {
      if (!recordTypeId) return;
      setIsLoadingProtocols(true);
      if (params.matrixSLA && typeof params.matrixSLA === 'object') {
        params.matrixSLA = params.matrixSLA.value;
      }

      params = formattedTags(params);
      params = formatParamsSLAParams(params);
      params = cleanObject(params);

      ProtocolFieldsService.getProtocolsByRecordType(recordTypeId, params)
        .then((response) => {
          const protocolsData = response.data.content;
          const quantity = response.data.quantity;
          setProtocols(protocolsData);
          setProtocolQuantity(quantity);
          if (quantity === 0 && showToastMessage) {
            toast.error('Nenhum registro foi encontrado', {
              autoClose: 3000,
              closeOnClick: true
            });
          }
        })
        .catch(() => {
          setProtocols(null);
        })
        .finally(() => {
          setIsLoadingProtocols(false);
        });
    },
    [recordTypeId]
  );

  const cleanObject = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        // eslint-disable-next-line no-unused-vars
        ([_, v]) =>
          v !== null && v !== '' && (!Array.isArray(v) || v.length > 0)
      )
    );
  };

  const formatParamsSLAParams = (params) => {
    const impactTypes = params.impact
      ? params.impact.map((item) => item.value.toString())
      : [];

    const criticalityTypes = params.criticality
      ? params.criticality.map((item) => item.value.toString())
      : [];

    const slaServiceExpired = params?.slaAtendimento?.value === 1 ? true : null;
    const slaServiceNotExpired =
      params?.slaAtendimento?.value !== undefined &&
      params?.slaAtendimento?.value !== 1
        ? true
        : null;
    const slaSolutionExpired = params?.slaSolucao?.value === 1 ? true : null;
    const slaSolutionNotExpired =
      params?.slaSolucao?.value !== undefined && params?.slaSolucao?.value !== 1
        ? true
        : null;

    params = {
      ...params,
      impactTypes,
      criticalityTypes,
      slaServiceExpired,
      slaServiceNotExpired,
      slaSolutionExpired,
      slaSolutionNotExpired
    };

    params = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== null)
    );

    delete params.impact;
    delete params.criticality;
    delete params.slaAtendimento;
    delete params.slaSolucao;

    return params;
  };

  const getProtocolOverallSLAInfoByRecordType = useCallback(
    (params = {}) => {
      if (params.matrixSLA && typeof params.matrixSLA === 'object') {
        params.matrixSLA = params.matrixSLA.value;
      }
      params = formattedTags(params);
      params = formatParamsSLAParams(params);
      params = cleanObject(params);
      ProtocolFieldsService.getProtocolOverallSLAInfoByRecordType(
        recordTypeId,
        params
      )
        .then((response) => {
          const data = response.data.content;
          setProtocolOverallSLAInfo(data);
        })
        .catch(() => {
          setProtocolOverallSLAInfo(null);
        });
    },
    [recordTypeId]
  );

  const getAndReturnProtocols = useCallback(
    (params = {}) => {
      if (params.matrixSLA && typeof params.matrixSLA === 'object') {
        params.matrixSLA = params.matrixSLA.value;
      }
      params = formattedTags(params);
      params = formatParamsSLAParams(params);
      params = cleanObject(params);
      return ProtocolFieldsService.getProtocolsByRecordType(
        recordTypeId,
        params
      );
    },
    [recordTypeId]
  );

  const getAndReturnProtocolsKanban = useCallback(
    (params = {}) => {
      if (params.matrixSLA && typeof params.matrixSLA === 'object') {
        params.matrixSLA = params.matrixSLA.value;
      }
      params = formattedTags(params);
      params = formatParamsSLAParams(params);
      params = cleanObject(params);
      return ProtocolFieldsService.getProtocolsByRecordTypeKanban(
        recordTypeId,
        params
      );
    },
    [recordTypeId]
  );

  return {
    protocols,
    protocolsQuantity,
    isLoadingProtocols,
    getProtocols,
    getAndReturnProtocols,
    getProtocolOverallSLAInfoByRecordType,
    protocolOverallSLAInfo,
    formatParamsSLAParams,
    getAndReturnProtocolsKanban
  };
}

export { useHandleProtocolListing };
